import { getUniqueName } from '@/shared/lib/format/getUniqueName';

import { TAB_DEFAULT_BASE_NAME } from '../constants/names';

export const getUniqueTabName = (existingNames: string[]): string => {
  return getUniqueName(existingNames, TAB_DEFAULT_BASE_NAME);
};
